// extracted by mini-css-extract-plugin
module.exports = {"bg_l5":"#8f8f8f","monoStack":"\"Roboto Mono\",monospace","slide":"Countdown_slide__JTpaP","on":"Countdown_on__mDMOY"};